// Wide board + fixed-column tile grid for the letter games with many tiles
// (Match Case: 52, Match Drag Letter: 26). Laying the tiles out wide and
// short keeps the board on one screen at full size instead of GameFitBox
// shrinking the whole board (header included) to fit a tall 5-6 column grid.
//
// Usage: add `tap-board-wide` to the .tap-letter-board-bg board and
// `tap-tile-grid` plus a column class (`tap-cols-12` / `tap-cols-9`) to the
// tile container; tiles keep their .letter-btn class.
export const TILE_GRID_CSS = `
  .tap-letter-board-bg.tap-board-wide {
    max-width: 1400px;
    width: 98%;
    min-height: 0;
    padding: 24px 16px 20px;
  }
  .tap-letter-board-bg.tap-board-wide.tap-board-md { max-width: 1200px; }
  .tap-tile-grid {
    display: grid !important;
    grid-template-columns: repeat(var(--tap-cols), minmax(0, 1fr));
    gap: 10px;
    width: 100%;
    min-height: 0 !important;
    margin-top: 4px;
  }
  .tap-tile-grid.tap-cols-12 { --tap-cols: 12; }
  .tap-tile-grid.tap-cols-9 { --tap-cols: 9; }
  .tap-tile-grid .letter-btn {
    width: 100% !important;
    height: auto !important;
    min-width: 0 !important;
    min-height: 0 !important;
    aspect-ratio: 4 / 3;
    margin: 0 !important;
  }
  .tap-tile-grid .letter-btn img {
    width: 82% !important;
    height: 82% !important;
    object-fit: contain;
    padding: 0 !important;
  }
  @media (max-width: 1200px) {
    .tap-tile-grid.tap-cols-12 { --tap-cols: 8; }
    .tap-tile-grid.tap-cols-9 { --tap-cols: 7; }
  }
  @media (max-width: 700px) {
    .tap-letter-board-bg.tap-board-wide { padding: 12px 8px; }
    .tap-tile-grid { gap: 6px; }
    .tap-tile-grid.tap-cols-12 { --tap-cols: 6; }
    .tap-tile-grid.tap-cols-9 { --tap-cols: 5; }
  }
`;
